require('./plugins/select2.full.min');
require('./plugins/flatpickr.min');
require('./modules/formInputs');
require('./modules/menu');
require('./modules/bootstrapTour');
require('./modules/tabpanel');
require('./modules/accountOpening');

$(function(){
    objectFitImages('.__objfit');
    $('.login').parent('.col-xl-10').removeClass('.col-xl-10');
    $('.list-group-title').parent('.list-group-item').addClass('__haschildren');
    $('.btn.__small span:last-of-type').empty();
});

$(function () {
        $('.accordion-head:contains("Documents")').each(function () {
            $(this).parent().addClass("__documents"); // matched td add NewClass
        });
        $('.select2').parent('.input_wrap').addClass('__noarrow');
    });

$(function(){
    // login screen __showHeader
    if ($('.loginheader').hasClass('__sticky')) {
        var position = $(window).scrollTop();

        if ($(window).scrollTop() == 0) {
            $('.header').addClass('__showHeader');
        }
        $(window).on('scroll', function() {
            var header = $('.loginheader');
            // var bannerHeight = $('.banner').height();
            var bannerHeight = 10;
            var scroll = $(window).scrollTop();

            // setting colour change
            if ($(window).scrollTop() > bannerHeight) {
                header.addClass('__stickyon');
                $('.icon-search, .burger-toggle').addClass('__black');
                $('.normlogo').css('display', 'none');
                $('.altlogo').css('display', 'block');
            } else if ($(window).scrollTop() < bannerHeight) {
                header.removeClass('__stickyon');
                $('.icon-search, .burger-toggle').removeClass('__black');
                $('.normlogo').css('display', 'block');
                $('.altlogo').css('display', 'none');
            }

            if ($(window).scrollTop() == 0) {
                header.removeClass('__stickyon');
                $('.icon-search, .burger-toggle').removeClass('__black');
                $('.normlogo').css('display', 'block');
                $('.altlogo').css('display', 'none');
            }

            // setting header to hide/show on scroll

            if (scroll > position) {
                $('.loginheader').removeClass('__showHeader');
            } else {
                $('.loginheader').addClass('__showHeader');
            }

            if (scroll < 10) {
                $('.loginheader').addClass('__showHeader');
            }

            position = scroll;
        });
    }
});

$('.nav-auxmob > button').click(function() {
    $('.burger').removeClass('__active');
    $('<div class="navwindow"></div>').hide();
    $('body').removeClass('__mobile');
    $('.navwrap').removeClass('__active');
    $('.navwrap')
        .find('ul')
        .removeClass('__active');
});

// Select with no search
$('.__select.__nosearch select').each(function() {
    var selectId = $(this).attr('id').parent;
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
        dropdownParent: selectId
    })
});
